import React, { useState } from 'react';
import EmployeeList from './EmployeeList';
import AddEmployee from './AddEmployee';
import EmployeeStatus from './EmployeeStatus';
import Headerpage from '../Headerpage';
import './EmployeesPage.css';

function EmployeesPage() {
  const [activePage, setActivePage] = useState('list'); // Default to Employee List

  const renderContent = () => {
    switch (activePage) {
      case 'list':
        return <EmployeeList />;
      case 'add':
        return <AddEmployee />;
      case 'status':
        return <EmployeeStatus />;
      default:
        return <EmployeeList />;
    }
  };

  return (
    <div className="employees-dashboard">
      <Headerpage />
      <div className="employees-layout">
        {/* Sidebar */}
        <div className="employees-sidebar">
          <button
            className={activePage === 'list' ? 'active' : ''}
            onClick={() => setActivePage('list')}
          >
            Employee List
          </button>
          <button
            className={activePage === 'add' ? 'active' : ''}
            onClick={() => setActivePage('add')}
          >
            Add Employee
          </button>
          <button
            className={activePage === 'status' ? 'active' : ''}
            onClick={() => setActivePage('status')}
          >
            Employee Status
          </button>
        </div>

        {/* Main Content */}
        <div className="employees-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default EmployeesPage;
